{
    "Policies_Bound.search.assignedTo": "FR: Assigned To",
    "Policies_Bound.search.allBrokers": "FR: All Brokers",
    "Policies_Bound.search.allProducts": "FR: All Products",
    "Policies_Bound.search.phone": "FR: Phone",
    "Policies_Bound.search.email": "FR: Email",
    "Policies_Bound.search.clear": "FR: Clear",

    "Policies_Bound.table.referenceNumber": "FR: Reference Number",
    "Policies_Bound.table.policyNumber": "FR: Policy Number",
    "Policies_Bound.table.name": "FR: Name",
    "Policies_Bound.table.product": "FR: Product",
    "Policies_Bound.table.creationDate": "FR: Creation Date",
    "Policies_Bound.table.assignedTo": "FR: Assigned To",
    "Policies_Bound.table.type": "FR: Type",
    "Policies_Bound.table.fname": "FR: First Name",
    "Policies_Bound.table.lname": "FR: Last Name",
    "Policies_Bound.table.search": "FR: Search"
}
